import { getManagedEquipmentDropDown } from "./ManagedEquipmentDropDownAction";

const dispatchGetManagedEquipmentDropDown = (dispatch: Function) => (subTypeId: number) => {
    dispatch(getManagedEquipmentDropDown(subTypeId));
};

const ManagedEquipmentDropDownDispatch = {
    dispatchGetManagedEquipmentDropDown
};

export default ManagedEquipmentDropDownDispatch